module.exports = __webpack_public_path__ + "static/media/appointment_slider_phone1.f25e56d9.png";